import { navLinks } from "@/mocks/siteData";

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 md:px-6 pt-14 pb-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-6">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className="ri-play-circle-fill text-xl" />
              </span>
              <span className="font-heading font-bold text-lg text-background-50">
                蓝莓视频
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200 max-w-md">
              一个专注整理蓝莓视频官网入口、最新地址与首页访问方法的信息页面，帮助用户少走弯路、避开虚假站点。
            </p>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-label tracking-widest uppercase text-secondary-300">
              页面导航
            </h3>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((item) => (
                <li key={item.id}>
                  <a
                    href={`#${item.id}`}
                    className="text-sm text-secondary-100 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h3 className="text-sm font-label tracking-widest uppercase text-secondary-300">
              重要提示
            </h3>
            <p className="mt-4 text-sm leading-relaxed text-secondary-200">
              本页为信息导航与访问方法说明，不对任何具体地址的可用性作出承诺。请始终通过可信渠道获取入口，并注意保护个人账号与隐私信息。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs md:text-sm text-secondary-300">
            © 2026 蓝莓视频 · 入口与最新地址访问指南
          </p>
          <div className="flex items-center gap-4 text-xs md:text-sm text-secondary-300">
            <a href="#top" className="hover:text-background-50 transition-colors cursor-pointer">
              回到顶部
            </a>
            <a href="#faq" className="hover:text-background-50 transition-colors cursor-pointer">
              帮助中心
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}